import type { PropsWithChildren } from 'react';

import type { DmpErrorResponse } from '@dmp/api';
import { useGlobalStore } from '@dmp/stores';
import type { AxiosError } from 'axios';

export const TenantConfig = ({ children }: PropsWithChildren) => {
  const isFetchingTenantConfig = useGlobalStore((s) => s.isFetchingTenantConfig);
  const tenantError = useGlobalStore((s) => s.tenantError) as AxiosError<DmpErrorResponse> | null;

  if (isFetchingTenantConfig) return null;

  if (tenantError) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center gap-[20px]">
        <div className="text-[40px] font-bold">{tenantError.status}</div>
        <div className="text-[20px]">{tenantError.response?.data?.message || 'Unknown Tenant error'}</div>
      </div>
    );
  }

  return children;
};
